const ROLES = {
  superAdmin: 'SUPER_ADMIN',
  companyAdmin: 'COMPANY_ADMIN',
  warehouseManager: 'WAREHOUSE_MANAGER',
  warehouseExecutive: 'WAREHOUSE_EXECUTIVE',
};

export default ROLES;
